/*
  webrtc streaming과 관련된 함수들의 모음
*/
import { PlayMode, ApiVersion } from '@/constants';
import rtcViewer from '@/api/webrtc';
import videojs from 'video.js';

let peerMixin = {
  methods: {
    // WebRTC 연결 가능 상태 일때까지 주기적으로 확인하여 true를 반환하는 메서드
    async checkWebRTCReady(contractCd, portNo) { 
      return new Promise (resolve => {
        let counter = 0;
        let checkWebRTCInterval = setInterval(async () => {
          const info = await this.networkController.getCameraInfo({}, contractCd, portNo);
          console.log('checkWebRTCReady', info.data);
					let operatingState = '';
					if (this.getUauApiVersion(info.data) === ApiVersion.NO_DATA_CH) { // apiVersion 231027 이하
						operatingState = info.data.webrtc.live.operatingState;
					} else { // apiVersion 240408 이상
						operatingState = info.data.webrtc.master.operatingState;
					}
          if (operatingState === 'KwrRun') {
            resolve(true);
            clearInterval(checkWebRTCInterval);
            checkWebRTCInterval = null;
          }
          if (counter > 30) { // 30초 이상 지속시 접속 불가 판정
            resolve(false);
            clearInterval(checkWebRTCInterval)
          }
          counter ++;
        }, 1000)
      })
    },
    // WebRTC 연결 가능한 Session 제한 수를 체크하여 가능 여부를 반환하는 메서드
    checkSessionLimitFull(contractCd, portNo) {
      return new Promise(resolve => {
        this.networkController.getCameraInfo({}, contractCd, portNo)
        .then(res => {
          if (res.data.webrtc && res.data.webrtc.sessions && res.data.webrtc.sessions.isFull) {
						resolve(true);
					}
          resolve(false);
        }).catch(error => {
          resolve(false);
        });
      })
    },
    // WebRTC 연결하기 위한 정보 객체를 생성하여 반환하는 메서드
    getWebRTCInformations(cameraInfo) {
      // UAU가 신버전인 경우는 LVPB로 변경
      const info = cameraInfo;
      const webrtcInforms = {
        key: null,
        channelName: null,
        clientId: String(Math.floor(Math.random() * 1000000)),
        sendVideo: false,
        sendAudio: false,
        forceTURN: false,
        wideScreen: false,
        openDataChannel: false,
        natTraversalDisabled: false,
        useTrickleICE: true,
      }
      if (this.getUauApiVersion(info) === ApiVersion.DATA_CH) {
        info.channelName = info.channelName.replace('LIVE', 'LVPB');
        webrtcInforms.openDataChannel = true;
      }
      webrtcInforms.channelName = info.channelName.replace('_TEST', '');
      webrtcInforms.key = info.channelName + String(Math.floor(Math.random() * 1000000));
      return webrtcInforms;
    },
    // UAU의 버전 분기에 따른 WebRTC 연결 후 재생 방법을 반환하는 메서드
    getUauApiVersion(data) {
			if (data.apiVersion >= ApiVersion.DATA_CH) { // apiVersion 240408 이상
				return ApiVersion.DATA_CH; // 신버전
			} else { // apiVersion 231027 이하
				return ApiVersion.NO_DATA_CH; // 구버전
			}
		},
    // video player 위에 session 초과에 대한 문구를 보여주는 메서드
    printTextInPlayer(id, text) {
      const player = document.getElementById(id);
      if (!player) return;
      const msgBox = document.createElement('div');
      msgBox.innerText = text;
      msgBox.style.position = 'absolute';
      msgBox.style.top = '10%';
      msgBox.style.left = '15%';
      player.parentElement.appendChild(msgBox);
    },
    // 한번의 호출로 webrtc 플레이 시작에 대한 모든 제어가 되도록 하는 메서드 (구현중)
    async startRTCStreaming(cameraInfo, videoElement, playerOptions, callbackObj) {
      const { contractCd, portNo } = cameraInfo;
      const webrtcInforms = this.getWebRTCInformations(cameraInfo);
      const isSessionFull = await this.checkSessionLimitFull(contractCd, portNo);
      if (isSessionFull) {
        if (callbackObj.isSessionFullCallback) callbackObj.isSessionFullCallback();
        return false;
      }
      await this.networkController.setCameraSignalingStart({}, contractCd, portNo);
      await this.checkWebRTCReady(contractCd, portNo);
      await rtcViewer.startViewer(videoElement, webrtcInforms);
      const player = videojs(videoElement, playerOptions, () => {
        player.el_.querySelector('video').src = null;
        player.el_.querySelector('video').srcObject = videoElement.srcObject;
        videoElement.play();
      })
    }
  }
}
export default peerMixin;